/**
 * AI Apply daily caps (A5, owner decision 2026-10-05: AI Apply is free with a
 * daily cap). Dependency-free so `entitlements.ts` (plan shapes) and
 * `daily-cap.ts` (enforcement) share one value without an import cycle.
 */

/** Free-tier AI Apply drafts per day. */
export const FREE_DAILY_AI_APPLIES = 5;

/** Pro AI Apply drafts per day: higher than free, still bounded by cost. */
export const PRO_DAILY_AI_APPLIES = 30;
